import { useRecoilState, useRecoilValue } from "recoil";
import { useToken } from "states/auth/hooks";
import { useLoadItems } from "states/company/hooks";
import { currentIdState, itemState } from "states/company";
import { create, update } from "api/company";
import DetailsForm from "./DetailsForm";

const stateName = "company";

const Details = () => {
  const [currentId, setCurrentId] = useRecoilState(currentIdState(stateName));
  const currentItem = useRecoilValue(
    itemState({ name: stateName, id: currentId })
  );
  const loadItems = useLoadItems(stateName);
  const token = useToken();

  const save = async (item: Company) => {
    if (currentId) {
      await update({
        id: currentId,
        entity: item,
        token,
      });
    } else {
      const { data } = await create({
        entity: item,
        token,
      });

      if (data) setCurrentId(data._id);
    }

    await loadItems();
  };

  return <DetailsForm id={currentId} item={currentItem} onSave={save} />;
};

export default Details;
